module.exports = __webpack_public_path__ + "static/media/spain.6a9dc11f.svg";